// ============================================
// Detail Module - Actions (ES6)
// 액션 버튼 및 채팅 기능
// ============================================

import { getSelectedContent, getDb, getAllPublishedContent } from './state.js';
import { getCurrentUser, setCurrentRoomId, setCurrentSessionId } from '../../app/state.js';
import { setUserCarbon } from '../../auth/state.js';
import { authFetch } from '../../shared/auth-fetch.js';
import { CHAT_ENDPOINTS } from '../../shared/api-endpoints.js';
import { loadSession } from '../../chat/load.js';
import { loadChatList, invalidateChatCache } from '../../chat/list.js';
import { showToast, showGlobalLoading, hideGlobalLoading } from '../../utils.js';
import { CURRENCY } from '../../constants.js';
import { openCarbonRechargeModal } from '../../mypage/carbon.js';
import { showSessionModal } from '../../chat/session-modal.js';

// ============================================
// 액션 버튼 업데이트
// ============================================

export async function updateDetailActionButtons(contentId) {
  const actionsContainer = document.getElementById('detailMainActions');
  const likeBtn = document.getElementById('detailLikeBtn');
  const selectedContent = getSelectedContent();
  const isMyCreation = selectedContent?.isMyCreation === true;

  // 임시저장(draft)은 액션 버튼/좋아요 숨김
  if (selectedContent?.status === 'draft') {
    actionsContainer.innerHTML = '';
    if (likeBtn) likeBtn.style.display = 'none';
    return;
  }

  // 내 작품이거나 비공개는 좋아요 버튼 숨김
  if (isMyCreation || selectedContent?.status === 'private') {
    if (likeBtn) likeBtn.style.display = 'none';
  } else {
    // 공개 상태면 좋아요 버튼 표시
    if (likeBtn) likeBtn.style.display = '';
  }

  const user = getCurrentUser();
  if (!user) {
    actionsContainer.innerHTML = `
      <button class="detail-action-btn primary" data-action="login">채팅하기</button>
    `;
    return;
  }

  const db = getDb();

  // chatRooms에서 publishedId로 기존 채팅 확인 (레거시 chats 제거됨)
  try {
    const roomsSnap = await db.collection('users').doc(user.uid)
      .collection('chatRooms')
      .where('publishedId', '==', contentId)
      .limit(1)
      .get();

    if (!roomsSnap.empty) {
      const roomDoc = roomsSnap.docs[0];
      const roomData = roomDoc.data();
      const roomId = roomDoc.id;
      const sessionCount = roomData.sessionCount || 1;

      actionsContainer.innerHTML = `
        <button class="detail-action-btn secondary" data-action="startNew" data-id="${contentId}">새로하기</button>
        <button class="detail-action-btn primary" data-action="continueRoom" data-room-id="${roomId}" data-session-count="${sessionCount}" data-last-session-id="${roomData.lastSessionId || ''}">이어하기</button>
      `;
    } else {
      actionsContainer.innerHTML = `
        <button class="detail-action-btn primary" data-action="startNew" data-id="${contentId}">채팅하기</button>
      `;
    }
  } catch (e) {
    console.error('Failed to check existing chatRooms:', e);
    actionsContainer.innerHTML = `
      <button class="detail-action-btn primary" data-action="startNew" data-id="${contentId}">채팅하기</button>
    `;
  }
}

// ============================================
// 채팅 시작/이어하기
// ============================================

export async function startNewChat(contentId) {
  // selectedContentForDetail에서 먼저 확인 (내 작품 등 객체로 전달된 경우)
  let content = getSelectedContent();
  if (!content || content.id !== contentId) {
    content = getAllPublishedContent().find(c => c.id === contentId);
  }
  if (!content) return;

  // 상세 모달 유지하고 채팅창만 열기
  showGlobalLoading();

  try {
    // 상세 모달의 모든 콘텐츠는 published 컬렉션에서 오므로 startPublishedChat 사용
    const response = await authFetch(CHAT_ENDPOINTS.startPublishedChat, {
      body: { contentId }
    });

    const data = await response.json();

    if (!response.ok) {
      if (response.status === 402) {
        showToast(`${CURRENCY.NAME}가 부족합니다. (필요: ${data.required}, 보유: ${data.current})`, 'error');
        // 충전 모달 띄우기
        openCarbonRechargeModal();
      } else {
        showToast(data.error || '채팅 생성 실패', 'error');
      }
      hideGlobalLoading();
      return;
    }

    // 카본 업데이트
    if (data.carbon !== undefined) {
      setUserCarbon(data.carbon);
    }

    // 새 세션 구조만 지원 (레거시 응답 제거됨)
    setCurrentRoomId(data.roomId);
    setCurrentSessionId(data.sessionId);
    hideGlobalLoading();
    invalidateChatCache();
    loadChatList(0, true);
    await loadSession(data.roomId, data.sessionId);
  } catch (e) {
    hideGlobalLoading();
    showToast('채팅 생성 실패: ' + e.message, 'error');
    console.error(e);
  }
}

export async function continueRoom(roomId, sessionCount, lastSessionId, title = '') {
  // 세션이 1개면 바로 입장, 여러개면 세션 모달
  if (sessionCount <= 1 && lastSessionId) {
    await loadSession(roomId, lastSessionId);
  } else {
    showSessionModal(roomId, title || '세션 목록');
  }
}

export function showAllContent(section) {
  // For now just show a toast - could implement a full page view later
  showToast('전체 보기 기능 준비 중');
}
